import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
import OverlayTrigger from '../overlay/OverlayTrigger';
import Tooltip from '../tooltip/Tooltip';
const ACTIVE_CLASS_NAME = 'active';
const SELECTED_CLASS_NAME = 'selected';
const TOOLTIP_DELAY = 1500;
const TreeSidebarCategories = (props) => {
    const { children, currentCategoryId, onSelectCategory = noop } = props;
    if (!children) {
        return null;
    }
    return (_jsx(_Fragment, { children: children.map(child => {
            const id = child.props.id;
            const icon = child.props.icon || '';
            const label = child.props.label;
            const statusClassName = classNames(currentCategoryId === id ? ACTIVE_CLASS_NAME : '', child.props.hasSelection && SELECTED_CLASS_NAME);
            const handleSelectCategory = (event) => {
                event.stopPropagation();
                onSelectCategory(id);
            };
            const category = (_jsx("li", Object.assign({ onClick: handleSelectCategory, className: statusClassName }, { children: _jsx("div", Object.assign({ className: 'selection-bubble' }, { children: _jsx("span", { className: `rioglyph ${icon}` }) })) }), id));
            if (label) {
                const tooltip = _jsx("span", { children: label });
                return (_jsx(OverlayTrigger, Object.assign({ placement: Tooltip.RIGHT, delay: TOOLTIP_DELAY, overlay: _jsx(Tooltip, Object.assign({ id: 'tooltip', width: 'auto' }, { children: tooltip })) }, { children: category }), `category-tooltip-${id}`));
            }
            return category;
        }) }));
};
TreeSidebarCategories.displayName = 'TreeSidebarCategories';
export default TreeSidebarCategories;
